import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AnnouncementApiService } from '../../../../services/announcement-api.service';
import { Announcement } from '../../../../types/announcement.types';
import { of } from 'rxjs';
import { DetailResponse } from '@synegen/utility';

export const announcementResolver: ResolveFn<DetailResponse<Announcement> | null> = (route) => {
  let id = route.paramMap.get('id');
  if ('create' === route.routeConfig?.path) {
    return of(null);
  }
  return inject(AnnouncementApiService).getAnnouncement(Number(id));
};
